import { render, staticRenderFns } from "./ContentHeading.vue?vue&type=template&id=a2562c1a&scoped=true&"
import script from "./ContentHeading.vue?vue&type=script&lang=js&"
export * from "./ContentHeading.vue?vue&type=script&lang=js&"
import style0 from "./ContentHeading.vue?vue&type=style&index=0&id=a2562c1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2562c1a",
  null
  
)

export default component.exports